import { Component, OnInit } from '@angular/core';
import { AppInsightsService } from './services/app-insights.service';
import { MaintenanceService } from './services/maintenance.service';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
  selector: 'tx-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private appInsightsService: AppInsightsService, private maintenanceService: MaintenanceService) {}

  get maintenanceMessage$() {
    return this.maintenanceService.message$;
  }
}
